import { render } from "./modulDialog.vue?vue&type=template&id=9c15fe4e&scoped=true"
import script from "./modulDialog.vue?vue&type=script&lang=js"
export * from "./modulDialog.vue?vue&type=script&lang=js"

import "./modulDialog.vue?vue&type=style&index=0&id=9c15fe4e&lang=less&scoped=true"
import "./modulDialog.vue?vue&type=style&index=1&id=9c15fe4e&lang=less"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c15fe4e"]])

export default __exports__